var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"schedule"}},[_c('b-container',[_c('h1',{staticClass:"titles"},[_vm._v("Programação")]),_c('p',[_vm._v("(Programação sujeita a alterações)")]),_c('AppScheduleList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }